import { createTheme } from '@mui/material';

const options = {
  themeName: 'Tyde Theme',
  palette: {
    primary: {
      color: '#fcfefe',
      light: '#51bdc3',
      main: '#51bdc3',
      dark: '#51bdc3',
      contrastText: '#fcfefe',
    },
    error: {
      color: '#fcfefe',
      light: '#e84848',
      main: '#e84848',
      dark: '#e84848',
      contrastText: '#fcfefe',
    },
    warning: {
      color: '#fcfefe',
      light: '#f3652d',
      main: '#f3652d',
      dark: '#f3652d',
      contrastText: '#fcfefe',
    },
    action: {
      color: '#fcfefe',
      light: '#51bdc3',
      main: '#51bdc3',
      dark: '#51bdc3',
      contrastText: '#fcfefe',
    },
    alternateTextColor: '#4a4a4a',
    canvasColor: '#616161',
    textColor: 'rgb(0, 0, 0)',
    secondaryTextColor: 'rgba(255, 255, 255, 0.54)',
    disabledColor: '#757575',
    accent1Color: '#5171c3',
  },
};

export const theme = createTheme(options);
